var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00049 5.50184C4.00049 5.10404 4.15851 4.72254 4.43979 4.44126C4.72108 4.15998 5.10258 4.00195 5.50037 4.00195H11.4999C11.8977 4.00195 12.2792 4.15998 12.5605 4.44126C12.8418 4.72254 12.9998 5.10404 12.9998 5.50184V11.5014C12.9998 11.8992 12.8418 12.2807 12.5605 12.5619C12.2792 12.8432 11.8977 13.0013 11.4999 13.0013H5.50037C5.10258 13.0013 4.72108 12.8432 4.43979 12.5619C4.15851 12.2807 4.00049 11.8992 4.00049 11.5014V5.50184Z",
    stroke: "#1DA5FF",
    strokeWidth: 1.49988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4.00172V2.50184C10.0003 2.10404 9.84225 1.72254 9.56097 1.44126C9.27969 1.15998 8.89819 1.00195 8.50039 1.00195H2.50086C2.10307 1.00195 1.72156 1.15998 1.44028 1.44126C1.159 1.72254 1.00098 2.10404 1.00098 2.50184V8.50137C1.00098 8.89916 1.159 9.28066 1.44028 9.56195C1.72156 9.84323 2.10307 10.0013 2.50086 10.0013H4.00074",
    stroke: "#1DA5FF",
    strokeWidth: 1.49988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.161cd98a6cb1f0f4e149b3c00fcb57da.svg";
export { ForwardRef as ReactComponent };